var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x83\xAF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M56.064 13.312L52.16 10.88C51.008 11.136 49.472 11.2 48.128 11.2H15.232C14.8399 11.2 14.4556 11.2 14.08 11.1996C11.8195 11.1974 9.87491 11.1818 8.448 11.072C8.576 12.416 8.64 13.824 8.64 15.296V16.192H14.08H49.344C48.704 23.744 46.912 31.936 43.264 37.568C38.08 45.76 28.928 51.328 19.52 53.888L23.872 58.24C34.176 54.912 42.88 48.384 48.064 40.256C52.736 33.024 54.08 23.872 55.232 16.32C55.296 15.68 55.744 13.952 56.064 13.312Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M8 13.5H53C49.5 43.5 37 51.5 20 56.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    d: "M8.448 11.072C8.576 12.416 8.64 13.824 8.64 15.296V16.192V28.992C8.64 30.208 8.576 31.552 8.448 33.088H14.208C14.08 31.488 14.08 29.888 14.08 28.992V16.192V11.1996C11.8195 11.1974 9.87491 11.1818 8.448 11.072Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    d: "M11.5 11V33.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWa);
export default __webpack_public_path__ + "static/media/wa.e25537461deb75e36cda71d951566e2c.svg";
export { ForwardRef as ReactComponent };